
import { defineComponent, PropType } from 'vue'

import { ReportMeta, ReportPageT } from '~/types/reportTypes'
import { containsElement, getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'PublicReportSidebar',
  props: {
    reports: {
      type: Array as PropType<Array<ReportPageT>>,
      required: true
    },
    ownerLogo: {
      type: String,
      default: ''
    },
    ownerLogin: {
      type: String,
      default: ''
    },
    reportId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
      switchToFallback: false,
      ReportMeta
    }
  },
  mounted() {
    this.$root.$on('ui:show-public-report-sidebar', () => {
      this.toggleSidebar(true)
    })
  },
  beforeDestroy() {
    this.$root.$off('ui:show-public-report-sidebar')
  },
  computed: {
    sidebarLinks() {
      return [
        {
          title: 'Summary',
          link: '#summary'
        },
        {
          title: 'Intended use',
          link: '#intended-use'
        },
        {
          title: 'Continuous Code Health',
          link: '#continuous-code-health'
        },
        {
          title: 'About DeepSource',
          link: '#about'
        }
      ]
    }
  },
  methods: {
    getDefaultAvatar,
    toggleSidebar(newIsOpen: boolean): void {
      this.isOpen = newIsOpen ?? !this.isOpen

      if (!process.client) return

      if (newIsOpen) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    },
    closeSidebar(event: Event): void {
      const target = event.target as HTMLElement
      const toggleButton = document.getElementById('mobile-sidebar-toggle')

      if (!toggleButton) {
        this.toggleSidebar(false)
      } else if (!containsElement(toggleButton, target) && target.id !== 'mobile-sidebar-toggle') {
        this.toggleSidebar(false)
      }
    }
  }
})
